module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/37ca9e8d78728a5d63dcbe97dcc4e5f2.png";